import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

type DisabledPluginProps = {
  disabled: boolean;
};

export const DisabledPlugin = ({ disabled }: DisabledPluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.setEditable(!disabled);
  }, [disabled]);

  return null;
};
